"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStartWallPath = function (data, rx, ry, hight, ir) {
    var sx = rx * Math.cos(data.startAngle);
    var sy = ry * Math.sin(data.startAngle);
    return "M " + ir * sx + " " + ir * sy + " L " + ir * sx + " " + (ir * sy + hight) + " L " + sx + " " + (sy + hight) + " L " + sx + " " + sy + " z";
};
